import { render, staticRenderFns } from "./ForestersCE-FR.vue?vue&type=template&id=25b5344a&scoped=true"
import script from "./ForestersCE-FR.vue?vue&type=script&lang=js"
export * from "./ForestersCE-FR.vue?vue&type=script&lang=js"
import style0 from "./ForestersCE-FR.vue?vue&type=style&index=0&id=25b5344a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5344a",
  null
  
)

export default component.exports